import React, { useState } from 'react'
import { ExecutionDataset } from '../components/ExecutionDataset'
import { HeaderContainer } from '../components/HeaderContainer'
import { TableData } from '../components/TableData'
import i18n from 'live/services/i18n'
import { DvDRow, emptyDvDDataset, addCalculatedDvDColumns, getVPHeight } from '../functions/functions'
export const DvDDataContext = React.createContext({})
export const DvDDataContextProvider = ({ children }) => {
    const [tableData, setTableData] = useState<DvDRow[]>(addCalculatedDvDColumns(emptyDvDDataset))
    const [dataRowCount, setDataRowCount] = useState<number>(0)
    const [unSavedData, setUnSavedData] = useState<boolean>(false)
    const [loadingDataset, setLoadingDataset] = useState<boolean>(false)
    const [showReprocessModal, setShowReprocessModal] = useState<boolean>(false)
    const heightOfCentralComponents = getVPHeight() * 0.7
    const [lastNewDataSyncTime, setlastNewDataSyncTime] = useState(0)
    const [lastDataEditTime, setlastDataEditTime] = useState(Date.now())
    const [isSyncForced, setIsSyncForced] = useState<boolean>(false)
    const [interventions, setInterventions] = useState<[]>([])
    const [reprocessParameters, setReprocessParameters] = useState<Record<string, unknown>>({})
    const [wellSyncStatus, setWellSyncStatus] = useState<string>('')
    const [showCopyDataForm, setShowCopyDataForm] = useState<Boolean>(false)
    const [copyMaxDate, setCopyMaxDate] = useState<number>(Date.now())
    return (
        <DvDDataContext.Provider
            value={{
                heightOfCentralComponents,
                tableData,
                setTableData,
                dataRowCount,
                setDataRowCount,
                unSavedData,
                setUnSavedData,
                loadingDataset,
                setLoadingDataset,
                lastNewDataSyncTime,
                setlastNewDataSyncTime,
                lastDataEditTime,
                setlastDataEditTime,
                isSyncForced,
                setIsSyncForced,
                showReprocessModal,
                setShowReprocessModal,
                interventions,
                setInterventions,
                reprocessParameters,
                setReprocessParameters,
                wellSyncStatus,
                setWellSyncStatus,
                showCopyDataForm,
                setShowCopyDataForm,
                copyMaxDate,
                setCopyMaxDate
            }}
        >
            {children}
        </DvDDataContext.Provider>
    )
}
